import React, { useRef } from 'react';
import { LexicalEditor } from 'lexical';
import { Popover, PopoverBody } from 'reactstrap';
import { useToggle } from '@hooks/useToggle';
import { applyStyleToSelection, FONT_SIZES, TOOLBAR_POPOVER_PROPS } from './utils';

/**
 * Get the display label for a font size value
 */
export const getFontSizeLabel = (fontSize: string): string => {
  return FONT_SIZES.find((s) => s.value === fontSize)?.label ?? 'Normal';
};

interface FontSizeDropDownProps {
  editor: LexicalEditor;
  fontSize: string;
}

export const FontSizeDropDown = ({ editor, fontSize }: FontSizeDropDownProps): React.ReactNode => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [popoverOpen, toggle] = useToggle(false);

  const handleFontSizeChange = (size: string) => {
    applyStyleToSelection(editor, { 'font-size': size });
    toggle();
  };

  const currentLabel = getFontSizeLabel(fontSize);

  return (
    <>
      <button
        ref={buttonRef}
        onClick={toggle}
        className='btn btn-transparent btn-sm border-0 flex-shrink-0 d-flex align-items-center'
        type='button'
        aria-label='Font size'
        aria-haspopup='true'
        aria-expanded={popoverOpen}
      >
        <span className='text-ThemeIconSecondary' style={{ fontSize: '13px', minWidth: '45px' }}>
          {currentLabel}
        </span>
        <i className='ms-1 fal fa-caret-down text-ThemeIconSecondary' />
      </button>
      <Popover {...TOOLBAR_POPOVER_PROPS} isOpen={popoverOpen} toggle={toggle} target={buttonRef}>
        <PopoverBody className='editor__toolbar__submenu p-1'>
          {FONT_SIZES.map(({ label, value }) => (
            <button
              key={value}
              onClick={() => handleFontSizeChange(value)}
              className={`btn btn-transparent btn-sm border-0 d-block w-100 text-start ${fontSize === value ? 'active' : ''}`}
              type='button'
            >
              {label}
            </button>
          ))}
        </PopoverBody>
      </Popover>
    </>
  );
};
